import { useQuery } from "react-query";
import { getProducerCodeReportDetails } from "../../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";

const useGetAllMappedToCDRC = () => {
  return useQuery(
    ["getProducerCodeReport"],
    () => getProducerCodeReportDetails(),
    {
      refetchOnWindowFocus: false,
    }
  );
};
export default useGetAllMappedToCDRC;
